import type { SerializedDrawing } from "@/stores/sessionStore";
import { safeSetItem } from "@/lib/lytick/safe-storage";

const KEY_PREFIX = "lytick-drawings:";

export function loadDrawingsForHash(hash: string): SerializedDrawing[] | null {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + hash);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    return parsed as SerializedDrawing[];
  } catch {
    return null;
  }
}

export function saveDrawingsForHash(hash: string, drawings: SerializedDrawing[]): void {
  try {
    if (drawings.length === 0) {
      localStorage.removeItem(KEY_PREFIX + hash);
      return;
    }
    safeSetItem(KEY_PREFIX + hash, JSON.stringify(drawings), "drawings");
  } catch {
    // removeItem or JSON.stringify failed — ignore
  }
}

export function getCurrentCsvHash(): string | null {
  try {
    const meta = sessionStorage.getItem("lytick-csv-meta");
    if (!meta) return null;
    return (JSON.parse(meta) as { contentHash?: string }).contentHash ?? null;
  } catch {
    return null;
  }
}
